import React, { useEffect, useMemo, useRef } from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { SimpleItem, Label, FormRef } from "devextreme-react/form";
import IPosteEnregistrement from "../../models/IPosteEnregistrement";
import { FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar } from '../base';
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import FormSysteme from '../../components/forms/form-systeme';
import useLookUpBase from '../../components/selectbox/LookupBase';
import GestionEntreprises from '../gestion-entreprises/gestion-entreprises';
import Guid from '../../models/Guid';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionPosteProps {
  isModeSelection?: boolean,
}

export default function GestionPosteEnregistrement({ isModeSelection }: IGestionPosteProps) {
  const posteEnregistrementFormDataSource = useCustomDataSource<IPosteEnregistrement, IPosteEnregistrement>({ path: "posteEnregistrement", primaryKey: "idPosteEnregistrement" });
  const { setMainForm, selectedDataRow: selectedPosteEnregistrement, mode, setMode, isFieldModifier, onFieldDataChanged, setIsFieldModifier, setSelectedDataRow } = posteEnregistrementFormDataSource;
  const { setSelectedValue } = useContextPopupPage();
  const { editorOptions: entrepriseEditorOption, PopupGestion: PopupGestionEntreprise } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'entreprise', showClear: mode !== Mode.Lecture,
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idEntreprise", Guid.empty.toString());
    },
    width: '350px',
    titre: 'Gestionnaire des entreprises'
  });
  const formRef = useRef<FormRef>(null);

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("nom")?.focus();
  }, [mode])

  const codeOptions = useMemo(() => {
    return { maxLength: 10, width: 50 };
  }, []);
  const telephoneOptions = useMemo(() => {
    return { maxLength: 20, width: 175 };
  }, []);
  const actifOptions = useMemo(() => {
    return { text: "Actif" }
  }, []);
  const acombaOptions = useMemo(() => {
    return { width: 225 }
  }, []);
  const nomEditorOptions = useMemo(() => {
    return { width: 350 };
  }, []);
  const courrielEditorOptions = useMemo(() => {
    return { width: 350 };
  }, []);
  const bureauCourantEditorOptions = useMemo(() => {
    return { width: 350, text: "Afficher le poste dans l'inventaire" };
  }, []);

  return (
    <FormListBase data={posteEnregistrementFormDataSource}>
      <FormListBaseGrid dataSource={posteEnregistrementFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier) setMode(Mode.Lecture);
          if (setSelectedValue && e.row?.data) {
            setSelectedValue(e.row.data);
          }
        }}
      >
        <Column key={"grid-col-code"} dataField={"code"} caption="Code" allowHiding={false} />
        <Column key={"grid-col-nom"} dataField={"nom"} caption="Nom" allowHiding={false} />
        <Column key={"grid-col-telephone1"} dataField={"telephone1"} caption="Téléphone" allowHiding={false} />
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedPosteEnregistrement?.nom || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture ? <FormListBaseTab>
        <PopupGestionEntreprise
          onSelectionchanged={(data: any) => {
            setIsFieldModifier(true);
            formRef.current?.instance().updateData("idEntreprise", data.idEntreprise);
          }}
        >
          <GestionEntreprises isModeSelection={true} />
        </PopupGestionEntreprise>
        <TabItem title="Informations">
          <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedPosteEnregistrement || {} as IPosteEnregistrement} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
            <SimpleItem key={"frm-nom"} dataField={"nom"} editorOptions={nomEditorOptions}>
              <Label text='Description' />
            </SimpleItem>
            <SimpleItem key={"frm-code"} dataField={"code"}
              editorOptions={codeOptions} />
            <SimpleItem key={"frm-telephone1"} dataField={"telephone1"}
              editorOptions={telephoneOptions}>
              <Label text={"Téléphone"} />
            </SimpleItem>
            <SimpleItem key={"frm-id-entreprise"} dataField={"idEntreprise"} editorOptions={entrepriseEditorOption} editorType={"dxSelectBox"}>
              <Label text={"Entreprise"} />
            </SimpleItem>
            <SimpleItem key={"frm-id-courriel"} dataField={"courriel"} editorOptions={courrielEditorOptions}>
              <Label text={"Courriel"} />
            </SimpleItem>
            <SimpleItem key={"frm-id-acomba"} dataField={"acombaProjet"} editorOptions={acombaOptions}>
              <Label text={"Numéro projet Acomba"} />
            </SimpleItem>
            <SimpleItem key={"frm-bureau-courant"} dataField={"bureauCourant"} editorType={"dxCheckBox"}
              editorOptions={bureauCourantEditorOptions}>
              <Label visible={false} />
            </SimpleItem>
            <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"}
              editorOptions={actifOptions}>
              <Label visible={false} />
            </SimpleItem>
          </Form>
        </TabItem>
        <TabItem title="Système"><FormSysteme formData={selectedPosteEnregistrement || {} as IPosteEnregistrement} /></TabItem>
      </FormListBaseTab> : null}
    </FormListBase>
  );
}